import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

export const localStorage = createLocalStorageProvider('jira_business_common');
